import { Text } from '@myinterview/component-library';
import React, { useEffect, useRef } from 'react';
import { timerCountDown } from '../utils/formatters.utils';

interface CountDownProps {
  countDown:number;
  forceMobileCounter?:boolean;
  numberOfSecondsToHighlight?: number;
}

export const CountDown = ({ countDown, forceMobileCounter = false, numberOfSecondsToHighlight = 0 }:CountDownProps) => {
  const coundownRef = useRef<HTMLDivElement>(null);
  const countDownFreeze = useRef(countDown);
  const lastCountDown = useRef(countDown + 1);

  useEffect(() => {
    const diff = (lastCountDown.current - countDown) / 100;
    const countDownInterval = setInterval(() => {
      const percentage = (Math.max(lastCountDown.current - 1, 0) / countDownFreeze.current) * 100;
      coundownRef.current?.style.setProperty('--myinterview-widget-p', percentage.toString());
      lastCountDown.current -= diff;
    }, 10);

    return () => {
      clearInterval(countDownInterval);
      lastCountDown.current = countDown;
    };
  }, [countDown]);

  const [minutes, seconds] = timerCountDown(countDown);

  return (
    <>
      <div className="myinterview-widget__countdown myinterview-widget__countdown-mobile" hidden={!forceMobileCounter}>
        <Text>
          <span>{minutes}</span>
          <span>:</span>
          <span className={countDown <= numberOfSecondsToHighlight ? 'myinterview-widget__countdown-mobile--red' : ''}>{seconds}</span>
        </Text>
      </div>
      <div ref={coundownRef} className="myinterview-widget__countdown myinterview-widget__countdown-desktop" hidden={forceMobileCounter}>
        <Text className="myinterview-widget__countdown-desktop-text" size="H1-Semibold" color="primary">{`${minutes}:${seconds}`}</Text>
      </div>
    </>
  );
};
